// extracted by mini-css-extract-plugin
export default {"link":"TermsDialog_link__d56wr"};